export default __webpack_public_path__ + "static/media/female-body-outline.edc23a32.jpg";